import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, ConnectedProps, useDispatch } from 'react-redux';

import { GetAvatar } from '../../../Utils/generateThumbnail';
import { Icon } from '../../../Components/UI';
import { ColumnProps } from 'antd/lib/table';
import BoxContainer from '../../../Components/UI/Containers/BoxContainer/BoxContainer';
import Ellipsis from '../../../Components/UI/Ellipsis';
import Table from '../../../Components/UI/Table';

import { MinhaContaActions } from '../../../Store/MinhaConta/MinhaConta.actions'
import { IGlobalReducerState } from '../../../Store/Base/interface/IGlobalReducerState';
import { stringToPhone, stringToCNPJ, stringToCEP } from '../../../Utils/MaskUtils';

import styles from './DadosEmpresa.module.scss';

const DadosEmpresa: FC<Props> = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation('minhaConta');

    const requiredLabel = t('common:required', { ns: 'common' });
    const hasPhone = !!(props.userInfo?.Company?.Phone && props.userInfo?.Company?.Phone !== '');
    const hasName = !!(props.userInfo?.Company?.Name && props.userInfo?.Company?.Name !== '');
    const hasZip = !!(props.userInfo?.Company?.Zip && props.userInfo?.Company?.Zip !== '');
    const hasStreet = !!(props.userInfo?.Company?.StreetAddress && props.userInfo?.Company?.StreetAddress !== '');
    const hasDistrict = !!(props.userInfo?.Company?.District && props.userInfo?.Company?.District !== '');
    const hasCity = !!(props.userInfo?.Company?.City && props.userInfo?.Company?.City !== '');

    const newDadosEmpresa = () => [
      { title: hasName ? t('dadosEmpresa.fieldCompanyName') : t('dadosEmpresa.fieldCompanyNameRequired'), value: hasName ? props.userInfo?.Company?.Name : '*' },
      { title: t('dadosEmpresa.fieldCnpj'), value: stringToCNPJ(props.userInfo?.Company?.CNPJ) },
      { title: hasPhone ? t('dadosEmpresa.fieldPhone') : t('dadosEmpresa.fieldPhoneRequired'), value: hasPhone ? stringToPhone(props.userInfo?.Company?.Phone) : '*' },
      { title: t('dadosEmpresa.fieldOwner'), value: props.userInfo?.Company?.OwnerName },
      { title: t('dadosEmpresa.fieldSite'), value: props.userInfo?.Company?.Site }
    ];

    const newEnderecoEmpresa = () => [
      { title: hasZip ? t('dadosEmpresa.fieldZip') : t('dadosEmpresa.fieldZipRequired'), value: hasZip ? stringToCEP(props.userInfo?.Company?.Zip) : '*' },
      { title: hasStreet ? t('dadosEmpresa.fieldStreet') : t('dadosEmpresa.fieldStreetRequired'), value: hasStreet ? props.userInfo?.Company?.StreetAddress : '*' },
      { title: t('dadosEmpresa.fieldNumber'), value: props.userInfo?.Company?.Number ?? '' },
      { title: hasDistrict ? t('dadosEmpresa.fieldDistrict') : t('dadosEmpresa.fieldDistrictRequired'), value: hasDistrict ? props.userInfo?.Company?.District : '*' },
      { title: hasCity ? t('dadosEmpresa.fieldCity') : t('dadosEmpresa.fieldCityRequired'), value: hasCity ? props.userInfo?.Company?.City : '*' }
    ];

    const collumnsTable = (title: string): Array<ColumnProps<any>> => [
      {
        title,
        dataIndex: 'title',
        className: styles['dadoObrigatorio'],
        render: (text: string) => (
          <div className={styles['titleItem']}>
            <span className={styles[text.substr(-1, 1) === '*' ? 'titleObrigatorio' : 'title']}>{text}</span>
          </div>
        )
      },
      {
        title: (
          <div className={styles['icon']}>
            <Icon color='cinzaIcone' icon='editar' onClick={() => dispatch(MinhaContaActions.setShowModalUpdateEmpresa(true))} />
          </div>
        ),
        dataIndex: 'value',
        className: styles['dadoObrigatorio'],
        render: (text: string) => (
          <div className={styles['valueItem']}>
            <span
              title={text === '*' ? requiredLabel : text}
              className={styles[text === '*' ? 'valueObrigatorio' : 'value']}
            >
              {text === '*' ? requiredLabel : text}
            </span>
          </div>
        )
      }
    ];

    return (
      <>
        <BoxContainer height={213}>
          <div className={styles['dadosEmpresaImg']}>
            <GetAvatar
              name={props.userInfo?.Company?.Name || ''}
              shape='square'
              fontSize={50}
              src={`${process.env.REACT_APP_IMAGE_STORAGE_URL?.concat(props.userInfo?.Company?.AvatarFileName)}`}
              thumbSrc={`${process.env.REACT_APP_IMAGE_STORAGE_URL?.replace('/images/', '/thumbnails/')}${props.userInfo?.Company?.AvatarFileName}`}
              thumbType="big"
            />
          </div>

          <div className={styles['dadosEmpresaName']}>
            <strong>
              <Ellipsis phrase={props.userInfo?.Company?.Name || ''} maxLength={13} />
            </strong>
          </div>
        </BoxContainer>

        <div className={styles['dadosEmpresaLeft']}>
          <Table
            dataSource={newDadosEmpresa().map((dado, index) => ({ ...dado, key: index }))}
            columns={collumnsTable(t('dadosEmpresa.tableSectionCompany'))}
          />
        </div>

        <div className={styles['dadosEmpresaRight']}>
          <Table
            dataSource={newEnderecoEmpresa().map((dado, index) => ({ ...dado, key: index }))}
            columns={collumnsTable(t('dadosEmpresa.tableSectionAddress'))}
          />
        </div>
      </>
    );
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.minhaConta,
});

const connector = connect(
  mapState,
);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

export default connector(DadosEmpresa);
